<template>
  <div>
    <div>
      <div class="add_car_header">
         <img @click="$emit('close')" class="float_right" src="./../imgs/叉 .png" alt="" >
        <span>一键加车</span>
      </div>
       <div class="action_header fSize_14 text_ccc">
          <div class="float_left goods_over" style="width:50%">{{ name }}</div>
         <span class="float_right">份</span>
          <van-icon class='float_right' size="22px" color="#74B42B" name="add" @click="addHeader" v-if='share == 0' />
          <van-stepper
            v-else
            :min="0"
            theme="round"
            class="stepper_header  float_right"
            button-size="22px"
            input-width="30px"
            integer
            async-change
            v-model.number="share"
            :disable-minus="share <= 0 ? true : false"
          />
        </div>
        <div class="content_div">
        <div  class="mgTop20" >
            <span>主料商品</span>
              <div class="mgTop20">
                <ul>
                  <li
                    :class="{
                      cell_cover: item.salePrice == null,
                      cook_li_mian: true,
                    }"
                    v-for="item in tradeCookbookDtlDTOS.filter(
                      (el) => el.classifyValue == 0
                    )"
                    :key="item.skuId"
                  >
                  <div class='cover_img'>
                    <img   :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
                  </div>
                    <div class="inline">
                      <div class="goods_over">
                        {{ item.goodsName + "(" + item.skuName + ")" }}
                      </div>
                      <div class="text_yellow fixed_bottom" :style="{'bottom': item.salePrice == null ? '6px' : '0'}"   >
                        <div   class="text_yellow" v-if="item.salePrice == null"
                          >商品失效</div
                        >
                        <div  v-else>
                          <div >¥{{ item.salePrice | filterNumTwo}}/ {{
                            item.saleUnitLabel
                              | filterUnit(item.saleRatio, item.goodsUnitLabel)
                          }}</div>
                        <div>
                        <div class="ty-left" style="height: 30px;margin-top: 16px;">
                          <span  style="margin-right: 6px;color:#666" > <span class="fSize_14"> 每份</span> {{ item.parameter }} {{item.goodsUnitLabel}} </span
                          >
                          <span class="text_yellow fSize_14">{{ share }}份：</span>
                          <span class="text_yellow fSize_14"
                            >{{ item.shareOrt ? item.shareOrt : 0}}{{ item.saleUnitLabel }}</span
                          >
                          <span
                            class="float_right"
                            :style="{'transform': 'translateY(-3px)'}"
                          >
                            <van-icon size="26px" color="#74B42B" name="add" @click='addOneCart(item)'  v-if='item.newOrderQty == 0' />
                            <van-stepper
                              v-else
                              :min="0"
                              class="stepper"
                              button-size="24px"
                              input-width="24px"
                              integer
                              async-change
                              v-model.number="item.newOrderQty"
                              @focus="changgeGoods(item)"
                              :disable-minus="item.newOrderQty <= 0 ? true : false
                              "
                            />
                          </span>
                        </div>
                      </div>
                        </div>
                      </div>
                         </div>
                  </li>
                </ul>
              </div>
        </div>
         <div class="mgTop20">
           <span>辅料商品</span>
           <div class="mgTop20">
             <ul>
                  <li
                    :class="{
                      cell_cover: item.salePrice == null,
                      cook_li_mian: true,
                    }"
                    v-for="item in tradeCookbookDtlDTOS.filter(
                      (el) => el.classifyValue == 1
                    )"
                    :key="item.skuId"
                  >
                  <div class='cover_img'>
                    <img   :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
                  </div>
                    <div class="inline">
                      <div class="goods_over">
                        {{ item.goodsName + "(" + item.skuName + ")" }}
                      </div>
                      <div class="text_yellow fixed_bottom"  :style="{'bottom': item.salePrice == null ? '6px' : '0px'}"   >
                        <div style="bottom:6px"  class="text_yellow" v-if="item.salePrice == null"
                          >商品失效</div
                        >
                        <div  v-else>
                          <div >¥{{ item.salePrice | filterNumTwo}}/ {{
                            item.saleUnitLabel
                              | filterUnit(item.saleRatio, item.goodsUnitLabel)
                          }}</div>
                        <div>
                        <div class="ty-left" style="height: 30px;margin-top: 16px;">
                          <span  style="margin-right: 6px;color:#666" > <span class="fSize_14"> 每份</span> {{ item.parameter }} {{item.goodsUnitLabel}} </span
                          >
                          <span class="text_yellow fSize_14">{{ share }}份：</span>
                          <span class="text_yellow fSize_14"
                            >{{ item.shareOrt ? item.shareOrt : 0}}{{ item.saleUnitLabel }}</span
                          >
                          <span
                            class="float_right"
                            :style=" item.newOrderQty == 0 ?  {'transform': 'translateY(-3px)'} : {'transform': 'translateY(-3px)'}"
                          >
                            <van-icon size="26px" color="#74B42B" name="add" @click='addOneCart(item)'  v-if='item.newOrderQty == 0' />
                            <van-stepper
                              v-else
                              :min="0"
                              class="stepper"
                              button-size="24px"
                              input-width="24px"
                              integer
                              async-change
                              v-model.number="item.newOrderQty"
                              @focus="changgeGoods(item)"
                              :disable-minus="item.newOrderQty <= 0 ? true : false
                              "
                            />
                          </span>
                        </div>
                      </div>
                        </div>
                      </div>
                         </div>
                  </li>
                </ul>
           </div>
         </div>
        </div>
     <van-row class="sure_car">
          <div @click="sendCar"  class="addCar fSize_14 float_right">
          一键加车
        </div>
        <div style="margin-left:6px" class="text_yellow float_right">￥{{ price }}</div>
        <div style="margin-left:4px" class="fSize_14 text_ccc float_right"> 合计{{ total }}件</div>
        </van-row>
    </div>
    <!-- 修改商品数量 -->
    <!-- <van-dialog
      v-if="show"
      confirmButtonColor="rgba(116, 180, 43, 1)"
      v-model="showDia"
      title="修改商品数量"
      show-cancel-button
      :beforeClose="beforeClose"
    >
      <input
        ref="dialog"
        @change="newOrderChange"
        type="text"
        v-model="changNum"
        class="changeInput"
      />
    </van-dialog> -->
  </div>
</template>
<script>
import filters from "@/assets/js/filter.js";

export default {
  components: {},
  props: {},
  watch: {
    share() {
      this.tradeCookbookDtlDTOS.forEach(item => {
        this.$set(
          item,
          "newOrderQty",
          Math.ceil(this.share / item.saleRatio * item.parameter)
        );
        this.$set(
          item,
          "shareOrt",
          filters.filterNumTwo(this.share / item.saleRatio * item.parameter)
          // this.share / item.saleRatio * item.parameter
        );
      });
    }
  },
  computed: {
    total() {
      let num = 0;
      this.tradeCookbookDtlDTOS.forEach(item => {
        if (item.salePrice != null && item.newOrderQty != 0) {
          num += item.newOrderQty;
        }
      });
      return num;
    },
    price() {
      let num = 0;
      this.tradeCookbookDtlDTOS.forEach(item => {
        if (item.salePrice != null) {
          num += item.newOrderQty * item.salePrice;
        }
      });
      return filters.filterNumTwo(num);
    }
  },
  created() {
    this.customerId = +localStorage.getItem("customerId");
    this.cookbookId = this.$route.query.cookbookId;
    if (this.cookbookId) {
      this.getDetail();
    }
  },
  data() {
    return {
      show: false,
      share: 0,
      customerId: "",
      cookbookId: "",
      showDia: false,
      changNum: 0,
      currentItem: {},
      tradeCookbookDtlDTOS: [],
      name: ""
    };
  },
  methods: {
    addOneCart(item) {
      item.newOrderQty = 1;
    },
    addHeader() {
      this.share = 1;
    },
    getDetail() {
      this.$axios.get(`trade/tradeCookbook/${this.cookbookId}`).then(res => {
        let { tradeCookbookDtlDTOS, name } = res.data.data;
        this.tradeCookbookDtlDTOS = tradeCookbookDtlDTOS
        this.name = name;
        this.tradeCookbookDtlDTOS.forEach(item => {
        this.$set(item, "newOrderQty", 0);
        this.$set(item, "shareOrt", 0);
        });
      });
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        if (
          this.changNum <= 0 ||
          String(this.changNum).length > 3 ||
          String(this.changNum).indexOf(".") == 1
        ) {
          this.$toast("商品数量必须大于0并且小于四位数的整数");
          done(false);
        } else {
          this.changgeGoodsNumDan();
          done(true);
        }
      } else {
        done();
      }
    },
    changgeGoodsNumDan() {
      let num = this.changNum;
      this.currentItem.newOrderQty = num;
      this.tradeCookbookDtlDTOS.forEach(item => {
        if (item.skuId == this.currentItem.skuId) {
          item.newOrderQty = this.currentItem.newOrderQty;
        }
      });
    },
    newOrderChange() {
      this.changNum = this.$refs.dialog.value;
    },
    changgeGoods(index) {
      this.changNum = index.newOrderQty;
      this.currentItem = index;
      this.showDia = true;
    },
    sendCar() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认加入购物车？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          let list = this.tradeCookbookDtlDTOS.filter(
            item => item.salePrice != null && item.newOrderQty != 0
          );
          list.forEach(item => {
            item.customerId = this.customerId;
            item.orderQty = item.newOrderQty;
          });
          if (list.length == 0) return this.$toast.fail("请先选择商品再加购");
          // let flag = list.some(item => item.orderQty == 0);
          // if (flag) return this.$toast("数量不能为0");
          this.$axios.post("trade/tradeCart/saveBatch", list).then(res => {
            if (res.data) {
              this.$emit("close");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang='scss' scoped>
/deep/ .van-field__control {
  width: 17%;
}
/deep/ .van-stepper {
  display: inline-block;
  /deep/ button {
    background-color: transparent;
  }
  /deep/ input {
    background-color: transparent;
  }
}
/deep/ .van-popup {
  overflow-y: hidden;
}
.add_car_header {
  padding: 12px 10px 16px 10px;
}
.action_header {
  background: url(./../imgs/矩形4.png) no-repeat;
  background-size: 100%;
  height: 30px;
  line-height: 30px;
  padding: 3px 12px;
  margin: 0 10px;
  box-sizing: border-box;
}
/deep/.stepper_header {
  border: 1px solid #74b42b;
  border-radius: 20px;
  line-height: normal;
  transform: translateY(2%);
  margin-right: 4px;
}
.stepper_header {
  /deep/ .van-stepper__minus {
    //#74B42B
    color: #74b42b;
    left: -1px;
    background-color: transparent;
    opacity: 1;
    border: 1px solid #74b42b;
  }
  /deep/ .van-stepper__plus {
    background: #74b42b;
    right: -1px;
  }
}
.addCar {
  background-image: url(../imgs/矩形1.png);
  background-size: 100%;
  width: 104px;
  text-align: center;
  height: 32px;
  color: #fff;
  background-repeat: no-repeat;
  margin-left: 12px;
}
.stepper {
  /deep/ button {
    background-color: transparent;
  }
  /deep/ input {
    background-color: transparent;
  }
}
.content_div {
  overflow-y: auto;
  padding: 0px 10px;
  height: 62vh;
  width: 100%;
  box-sizing: border-box;
}
.sure_car {
  padding: 14px 8px;
  background-color: #fff;
  box-shadow: 0px 4px 7px #514a4a;
  line-height: 32px;
  width: 100%;
  z-index: 999;
  box-sizing: border-box;
  .van-button {
    padding: 0 27px;
    margin-right: 10px;
  }
}
// .cook_li_mian .inline {
//   height: 88px;
//   position: relative;
//   .fixed_bottom{
//     position:absolute;
//     bottom: 0;
//     width:100%;
//   }
// }
// .cook_li_mian{
//   .inline{
//     height: 88px; overflow: hidden
//   }
//     position: relative;
//   .fixed_bottom{
//     position:absolute;
//     bottom: 30px;
//     width: 70%;
//   }
// }
// .fixed_bottom {
//   margin-top: 24px;
// }
</style>